import $ from 'jquery'

export function initCookies() {

    // //console.log('init cookies');

}


export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


export function setCookie(cname, cvalue, cexpires) {
    document.cookie = cname + "=" + cvalue + ";" + cexpires + ";path=/";
}


export function checkCookie(cname, cvalue, exdays, cset = true) {
    const cookie = getCookie(cname);

    if (cookie != "") {
        return true;
    } else {
        if (cname != "" && cvalue != null && cset) {
            setCookie(cname, cvalue, exdays);
        }
    }
    return false;
}
